<script lang="ts" setup>
import { computed} from 'vue';
import BarLeft from '@/components/block/BarLeft.vue';
import BarTop from '@/components/block/BarTop.vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const pageName = computed<string>(() => String(route.meta.namePage || ''));
const pageDesc = computed<string>(() => String(route.meta.descPage || ''));
const pageBack = computed<string>(() => String(route.meta.pageBack || ''));
</script>

<template>
  <BarLeft />
  <BarTop :namePage="pageName" :descPage="pageDesc" :backPage="pageBack" />

  <div class="dashboard">
    <div class="components">
      <router-view/>
    </div>
  </div>
</template>